import { ChangeField, Context, DepartInfo, ScreenSize, UpdateMode, PassParams, TypeEnum } from ".";
import { ElMessage } from "element-plus";
import { initApp } from "../apis/httpHelper"
import store from "../store/store"
import dayjs from "../utils/dayjs";
import _, { forEach } from "lodash";

let task: Promise<boolean>;

let initAppData = async function(){
    if(!task){
        task = initAppTask()
    }
    return await task;
} 

let initAppTask = async function() {
    if(store.state.appInitState){
        return true;
    }
    else{
        let appState = await initApp();
        store.commit("SetAppInitState", true);
        store.commit("SetSiteInfo",appState.Result.SiteInfo);
        store.commit("SetDisplayName",appState.Result.SiteInfo.SiteName);
        if(appState.Result.UserInfo.IsAuthenticated){
            store.commit("SetUserInfo",appState.Result.UserInfo);
        }
        return true;
    }
}

let canUserAccess = function():boolean{
    return store.state.isLogin;
}

let setDocumentTitle = function(title: string){
    document.title = title;
}

let isWeChat = function(){
    let ua = navigator.userAgent.toLowerCase();
    let result = ua.match(/MicroMessenger/i);
    if(result === null){
        return false;
    }
    else if(result.includes("micromessenger")){
        return true;
    }
    else{
        return false;
    }
}

function JSONReplacer(key:any, value:any) {
    if (value == undefined) {
      return null;
    }
    return value;
}

let isWorkWeChat = function(){
    let ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("micromessenger") > -1 && ua.indexOf("wxwork") > -1
}

let qweIsEmpty = function(obj:any){
    if(obj == undefined || obj == null){
        return true;
    }
    else{
        if(typeof obj == "string"){
            obj = obj.replace(/\s+/g, "");
            if (obj === "") {
                return true;
            }
            else {
                return false;
            }
        }
        else if(Array.isArray(obj)){
            return obj.length == 0;
        }
        else{
            return false;
        }
    }
}

let qweIsPhoneEnv = function(){
    return true;
}

class AppScreen {
    constructor() {
        this.initAppScreen()
    };
    screenSize:ScreenSize | undefined;
    width:number |undefined;
    height:number |undefined;
    isPhoneEnv:boolean | undefined;
    initAppScreen(){
        this.isPhoneEnv = qweIsPhoneEnv();
        this.height = document.body.offsetHeight;
        this.width = document.body.offsetWidth;
        if(this.width < 768){
            this.screenSize = ScreenSize.xs;
        }
        else if(this.width < 992){
            this.screenSize = ScreenSize.sm;
        }
        else if(this.width < 1200){
            this.screenSize = ScreenSize.md;
        }
        else if(this.width < 1980){
            this.screenSize = ScreenSize.lg;
        }
        else {
            this.screenSize = ScreenSize.xl;
        }
    }
}

let handlerUpdateParams = function(params: Array<ChangeField>, context:Context, passParams: Array<PassParams>){
    let ParameterArray = new Array();
    
    (params || []).forEach(x => {
        let filed = {
            "Name": x.FieldName,
            "UpdateMode":x.UpdateMode,
            "Value": null
        };
        switch (x.UpdateMode) {
            case 0:
                filed.Value = x.Value;
                break;
            case 1:
                filed.Value = x.Value;
                break;
            case 2:
                if(passParams == undefined){
                    let fuc = new Function("Context", "Content", x.Value);
                    filed.Value = fuc(context, context.Content);
                }
                else{
                    let keys = passParams.map(x=>x.Key);
                    let values = passParams.map(x=>x.Value);
                    filed.Value = (new Function("Context", "Content", ...keys, x.Value))(context, context.Content, ...values);
                }
                filed.UpdateMode = UpdateMode.Value;
                break;
            default:
                break;
        }
        ParameterArray.push(filed);
    });
    return ParameterArray;
}
/**
 * 
 * @param Scale 需要生成的位数
 * @returns guid
 */
let qweGuid = function (Scale = 26) {
    let guid = "";
    let _encode32Chars = "0123456789abcdefghijklmnopqrstuvwxyz";

    for (let i = 0; i < Scale; i++) {
        guid = guid + _encode32Chars[s()];
    }
    return guid;
}

function s() {
    return Math.floor(Math.random() * 36);
}

let qweLetterGuid = function (Scale = 20) {
    let guid = "";
    let _encode32Chars = "abcdefghijklmnopqrstuvwxyz";

    for (let i = 0; i < Scale; i++) {
        guid = guid + _encode32Chars[LetterS()];
    }
    return guid;
}

function LetterS() {
    return Math.floor(Math.random() * 26);
}

let checkEffectiveFilter = function(dataFilterData:any){
    let handlerOrginalFilterTag = true;
    if (dataFilterData == undefined || dataFilterData == null) {
        handlerOrginalFilterTag = false;
    }
    else {
        if (dataFilterData.constructor === Object) {
            if (dataFilterData.hasOwnProperty("logic") && dataFilterData.hasOwnProperty("filters")) {
                handlerOrginalFilterTag = true;
            }
            else if(dataFilterData.hasOwnProperty("field") && dataFilterData.hasOwnProperty("operator") && dataFilterData.hasOwnProperty("value")) {
                handlerOrginalFilterTag = true;
            }
        }
        else {
            handlerOrginalFilterTag = false;
        }
    }
    return handlerOrginalFilterTag;
};

let handleMediaDevices = function () {
    if (navigator.mediaDevices === undefined) {
        ElMessage.warning("当前浏览器不支持拍照功能，如需完整使用功能，请使用Chrome浏览器操作本系统");
        return false;
    }
    // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
    // 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
    if (navigator.mediaDevices.getUserMedia === undefined) {
        ElMessage.warning("当前浏览器不支持拍照功能，如需完整使用功能，请使用Chrome浏览器操作本系统");
        return false;
    }
    return true;
}

let listToTree = function (departList:Array<DepartInfo>) {
    let resultMap = new Map<number,Array<DepartInfo>>();
    departList.forEach(x => {
        x.Children = new Array<DepartInfo>();
        let groupValue = resultMap.get(x.Parentid) || new Array<DepartInfo>();
        groupValue.push(x);
        resultMap.set(x.Parentid, groupValue);
    });
    resultMap.forEach((x, key) => {
        let index = departList.findIndex(y => y.Id == key);
        x = x.sort(z => z.Order);
        if (index != -1) {
            departList[index]["Children"] = x;
            resultMap.delete(key);
        }
    });
    let resultArray = Array.from(resultMap.values()) || [];
    let result = new Array<DepartInfo>(); 
    resultArray.forEach(x=>{
        result = result.concat(x)
    })
    return result;
}

let mockFormSubmit = function(url:string,obj:Object, target = "_blank"){
    const form = document.createElement('form');
    
    form.method = "post";
    form.target = target;
    form.action = store.state.baseUrl + url;
    document.body.appendChild(form);
  
    const formField = document.createElement('input');
    formField.type = 'hidden';
    formField.name = "__RequestVerificationToken";
    formField.value = store.state.requestVerificationToken;

    form.appendChild(formField);
    for(const [key, val] of Object.entries(obj)) {
        const formField = document.createElement('textarea');
        formField.name = key;
        formField.value = val;
        form.appendChild(formField);
    }
    form.submit();
    form.remove();
}

let dayjsDate = function(obj:string){
    return dayjs(obj)
} 

let dayDate = function(obj:Date){
    return dayjs(obj).format('YYYY-MM-DD')
}

let dayDateTime = function(obj:Date){
    return dayjs(obj).format('YYYY-MM-DD HH:mm:ss')
}

let dayDiff = function(currentUtc:Date, previousUtc:Date){
    let dayjsCurrent = dayjs(currentUtc);
    let dayjsPrevious = dayjs(previousUtc);
    let diffs = Math.floor(Math.abs(dayjsCurrent.diff(dayjsPrevious)/1000));
    let second = diffs % 60;
    let minute = ((diffs - second) / 60) % 60;
    let hours = ((diffs - second - minute * 60) / 3600) % 24;
    let day = Math.floor(diffs/86400);
    if(day >0){
        return `${day}天${hours}小时${minute}分钟${second}秒`
    }
    else{
        if(hours>0){
            return `${hours}小时${minute}分钟${second}秒`
        }
        else{
            if(minute > 0){
                return `${minute}分钟${second}秒`
            }
            else{
                return `${second}秒`
            }
        }
    }
}

let dayWeekDayDiff = function(currentUtc:Date, previousUtc:Date){
    let dayjsCurrent = dayjs(currentUtc);
    let dayjsPrevious = dayjs(previousUtc);
    let diffs = Math.floor(Math.abs(dayjsCurrent.diff(dayjsPrevious)/1000));
    let second = diffs % 60;
    let minute = ((diffs - second) / 60) % 60;
    let hours = ((diffs - second - minute * 60) / 3600) % 24;
    let day = Math.floor(diffs/86400);
    if(day >0){
        return `${day}天${hours}小时${minute}分钟${second}秒`
    }
    else{
        if(hours>0){
            return `${hours}小时${minute}分钟${second}秒`
        }
        else{
            if(minute > 0){
                return `${minute}分钟${second}秒`
            }
            else{
                return `${second}秒`
            }
        }
    }
}

function qweLeft(value: number, Bits:number) {
    let result = "";
    result = String(Math.trunc(value));
    if (result.length < Bits) {
        let count = Bits - result.length;
        for (let i = 0; i < count; i++) {
            result = "0" + result;
        }
    }
    return result;
}

function singleDataConvert(dataValue:any, dataType:string){
    switch (dataType){
        case "BooleanField":
            return dataValue ? "是" : "否";
        case "AttachFileField":
        case "ImageField":
            if (dataValue != null &&  dataValue instanceof Array) {
                return dataValue.map((x:any, index:any) => {
                    return "<a class='fujian' href='" + x.Url + "'>" + x.Name + "</a>"
                })
            }
            return dataValue;
        case "ButtonField":
        case "ComputedObjectField":
        case "ContentPickerField":
        case "CorrelationField":
        case "DescriptionField":
        case "HtmlField":
        case "LinkQueryField":
        case "SubFormField":
            break;
        case "DateField":
            return dayjs(dataValue).isValid() ? dayjs(dataValue).format("YYYY-MM-DD") : "" ;
            break;
        case "DepartField":
            return (dataValue || []).map((x:any)=>x.DepartName).join(",");
            break;
        case "MultChoiceProField":
            return (dataValue || []).join(",")
            break;
        case "PositionField":
            let value =  dataValue || {Cascader: [], Detail: ""};
            return value.Cascader.join("") + (value.Detail || "")
            break;
        case "SignField":
            break;
        case "SingleChoiceProField":
            return  dataValue;
            break;
        case "SingleDepartField":
            return (dataValue || { "DepartName": ""})?.DepartName
            break;
        case "SingleUserField":
            return (dataValue || { "NickName": "" })?.NickName
            break; 
        case "MultTextField":
        case "NumericField":  
        case "PhoneField":
        case "PrimaryKeyField":
        case "TextField": 
            return  dataValue;
            break;
        case "UserField":
            return (dataValue || []).map((x:any)=>x.NickName).join(",")
            break;
    }
    return dataValue;
}

const qweEquals = {
    arrayEqual: function(oldValue:Array<any>, newValue:Array<any>):boolean{
        if (oldValue == null)
        {
            return newValue == null;
        }
        else
        {
            if (newValue == null)
            {
                return false;
            }
            else{
                return oldValue.length == newValue.length && newValue.every(x => oldValue.includes(x));
            }
        }
    },

    dateEqual:function(oldValue:Date, newValue:Date){
        return oldValue.getTime() == newValue.getTime();
    },

    objectEqual:function(oldObj:object, newObj:object):boolean{
        let oldKeys = Object.keys(oldObj);
        let newKeys = Object.keys(newObj);
        if(oldKeys.length != newKeys.length){
            return false;
        }
        else if(!this.arrayEqual(oldKeys, newKeys)){
            return false;
        }
        else{
            for(let i = 0; i< oldKeys.length; i++){
                let key = oldKeys[i];
                let oldValue = oldObj[key];
                let newValue = newObj[key];

                let oldValueType = Object.prototype.toString.call(oldValue);
                let newValueType = Object.prototype.toString.call(newValue);
                if(oldValueType != newValueType){
                    return false;
                }
                else{
                    if(oldValueType == TypeEnum.Array){
                        return this.arrayEqual(oldValue, newValue);
                    }
                    else if(oldValueType == TypeEnum.Object){
                        return this.objectEqual(oldValue, newValue) as boolean;
                    }
                    else{
                        return oldValue == newValue;
                    }
                }
            }
            return false;
        }
    }
}

function rebuildNewObjct(obj:any){
    let newObj = {};
    let keys = Object.keys(obj).sort();
    for(let i = 0; i< keys.length; i++){
        let key = keys[i];
        let value = obj[key];
        let valueType = Object.prototype.toString.call(value);
        if(valueType == TypeEnum.Array){

        }
        else if(valueType == TypeEnum.Object){
            newObj[key] = rebuildNewObjct(value);
        }
        else{
            newObj[key] = value;
        }
    }
    return newObj;
}

// 进入全屏模式 
// function enterFullscreen(element:Element) {
// 	if (element.requestFullscreen) {
// 		element.requestFullscreen();
// 	} else if (element.webkitRequestFullscreen) {
// 		element.webkitRequestFullscreen();
// 	} else if (element.mozRequestFullScreen) {
// 		element.mozRequestFullScreen();
// 	} else if (element.msRequestFullscreen) {
// 		element.msRequestFullscreen();
// 	}
// }

// // 退出全屏模式 
// function exitFullscreen() {
// 	if (document.exitFullscreen) {
// 		document.exitFullscreen();
// 	} else if (document.webkitExitFullscreen) {
// 		document.webkitExitFullscreen();
// 	} else if (document.mozCancelFullScreen) {
// 		document.mozCancelFullScreen();
// 	} else if (document.msExitFullscreen) {
// 		document.msExitFullscreen();
// 	}
// }

// // 监听全屏状态变化事件 

// function handleFullscreenChange1(handleFullscreenChange){
//     document.addEventListener('fullscreenchange', handleFullscreenChange);
//     document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
//     document.addEventListener('mozfullscreenchange', handleFullscreenChange);
//     document.addEventListener('MSFullscreenChange', handleFullscreenChange);
// }


// function handleFullscreenChange() {
// 	if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
//       // 进入全屏模式 
//     } else { 
//       // 退出全屏模式 
//     }
// }

window.MockFormSubmit = mockFormSubmit;
window.QweIsEmpty = qweIsEmpty;
window.QweGuid = qweGuid;

let QweCommonHelper = {
    Date:{
        dayjsDate,
        dayDate,
        dayDateTime,
        dayDiff,
        dayWeekDayDiff
    },
    Common:{
        qweIsEmpty,
        qweGuid,
        checkEffectiveFilter,
        qweLeft
    },
    lodash: _
}

window.Qwe = window.Qwe == undefined ? {} : window.Qwe;
window.Qwe.CommonHelper = QweCommonHelper;

export { 
    JSONReplacer,
    dayDate,
    dayDateTime,
    dayDiff,
    dayWeekDayDiff,
    mockFormSubmit,
    qweLetterGuid,

    isWeChat,
    isWorkWeChat,
    
    singleDataConvert,

    AppScreen,
    qweIsEmpty, 
    handlerUpdateParams, 
    qweGuid, 
    checkEffectiveFilter, 
    handleMediaDevices,
    listToTree,
    qweLeft,
    
    canUserAccess,
    initAppData,
    qweEquals,
    rebuildNewObjct
}